module.exports = __webpack_public_path__ + "img/toa-exportar.bf40ccd1.jpg";